import LegalLayout, { LegalSection, LegalList } from "./LegalLayout";

export default function TermsPage() {
  return (
    <LegalLayout
      title="이용약관"
      subtitle="K-ArtPEN 서비스 이용에 관한 권리, 의무 및 책임사항을 규정합니다."
      updatedAt="2026년 3월 27일"
    >
      <LegalSection title="제1조 (목적)">
        <p>본 약관은 주식회사 툴뮤직(이하 "회사")이 운영하는 K-ArtPEN 플랫폼(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
      </LegalSection>

      <LegalSection title="제2조 (정의)">
        <LegalList items={[
          "\"서비스\"란 회사가 제공하는 K-ArtPEN 문화예술 기업 경영 시뮬레이션 교육 플랫폼을 의미합니다.",
          "\"이용자\"란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 의미합니다.",
          "\"회원\"이란 서비스에 접속하여 본 약관에 동의하고 계정을 생성한 자를 말합니다.",
          "\"강사\"란 관리자 권한으로 워크스페이스를 생성·운영하는 회원을 말합니다.",
          "\"학생\"이란 강사가 생성한 워크스페이스에 참여하는 회원을 말합니다.",
          "\"워크스페이스\"란 강사가 생성하는 교육 단위 공간으로, 여러 학생이 팀을 이루어 시뮬레이션을 진행하는 환경을 의미합니다.",
        ]} />
      </LegalSection>

      <LegalSection title="제3조 (약관의 효력 및 변경)">
        <p>본 약관은 서비스를 이용하고자 하는 모든 이용자에게 적용됩니다. 회사는 필요한 경우 약관을 변경할 수 있으며, 변경된 약관은 서비스 내 공지를 통해 효력이 발생합니다.</p>
      </LegalSection>

      <LegalSection title="제4조 (회원가입)">
        <p>이용자는 회사가 정한 양식에 따라 이메일, 비밀번호 등 필수 정보를 기재하고 본 약관에 동의함으로써 회원가입을 신청합니다. 다음 각 호에 해당하는 경우 가입을 거절할 수 있습니다.</p>
        <LegalList items={[
          "실명이 아닌 허위 정보로 신청한 경우",
          "만 14세 미만인 경우",
          "이전에 약관 위반으로 탈퇴 처리된 경우",
          "기타 서비스 운영에 현저히 지장을 초래할 우려가 있는 경우",
        ]} />
      </LegalSection>

      <LegalSection title="제5조 (서비스의 제공)">
        <p>회사는 다음과 같은 서비스를 제공합니다.</p>
        <LegalList items={[
          "문화예술 기업 경영 시뮬레이션 콘텐츠",
          "직무별 대시보드, 인박스, 전자결재, 재무 ERP 기능",
          "강사용 워크스페이스 관리 및 이벤트 발송 도구",
          "AI NPC 협상 시뮬레이션",
          "팀 기반 멀티플레이 환경",
        ]} />
        <p className="mt-3">서비스는 원칙적으로 연중무휴 24시간 제공되나, 정기 점검 또는 시스템 장애 등으로 일시 중단될 수 있습니다.</p>
      </LegalSection>

      <LegalSection title="제6조 (이용자의 의무)">
        <p>이용자는 다음 행위를 하여서는 안 됩니다.</p>
        <LegalList items={[
          "타인의 계정을 도용하거나 허위 정보를 등록하는 행위",
          "서비스를 통해 수집한 정보를 상업적으로 이용하는 행위",
          "회사의 저작권 등 지식재산권을 침해하는 행위",
          "서비스의 정상적인 운영을 방해하는 행위",
          "관련 법령 또는 본 약관을 위반하는 행위",
        ]} />
      </LegalSection>

      <LegalSection title="제7조 (저작권)">
        <p>서비스 내 모든 콘텐츠(텍스트, 이미지, 시뮬레이션 시나리오, UI 등)의 저작권은 회사에 귀속됩니다. 이용자는 회사의 사전 동의 없이 이를 복제, 전송, 배포할 수 없습니다.</p>
      </LegalSection>

      <LegalSection title="제8조 (책임의 제한)">
        <LegalList items={[
          "회사는 천재지변, 전쟁, 테러 등 불가항력적 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.",
          "회사는 이용자의 귀책사유로 인한 서비스 이용의 장애에 대해 책임을 지지 않습니다.",
          "K-ArtPEN은 교육 목적의 시뮬레이션 플랫폼으로, 실제 기업 경영 결과를 보장하지 않습니다.",
        ]} />
      </LegalSection>

      <LegalSection title="제9조 (분쟁 해결)">
        <p>본 약관에 관한 분쟁은 대한민국 법률을 적용하며, 관할 법원은 회사 소재지를 관할하는 법원으로 합니다. 문의사항은 <span className="text-[#7A9BFF]">eunhyun1@naver.com</span>으로 연락 바랍니다.</p>
      </LegalSection>

      <LegalSection title="부칙">
        <p>본 약관은 2026년 3월 27일부터 시행합니다.</p>
        <p className="mt-1">주식회사 툴뮤직 | 대표: 툴뮤직 대표이사</p>
      </LegalSection>
    </LegalLayout>
  );
}
